export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const auth0Config = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
};

export const cognitoConfig = {
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  clientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
};

// export const baseUrl =
//   process.env.NODE_ENV === "development"
//     ? "http://localhost:3001/v1"
//     : "https://api.tiehoitokunta.fi/v1";

// Choose env: APP_ENV > NODE_ENV (dev | stage | production)
// const ENV = (process.env.NODE_ENV || "production").toLowerCase();

// const BASES: Record<string, string> = {
//   development: "http://localhost:3001/v1",
//   stage: "https://apidev.tiehoitokunta.fi/v1",
//   production: "https://api.tiehoitokunta.fi/v1",
// };

// // Final base URL
// export const baseUrl = BASES[ENV] || BASES.production;

// const ENV = (process.env.REACT_APP_APP_ENV || "production").toLowerCase();

// const BASES: Record<string, string> = {
//   development: "http://localhost:3001/v1",
//   stage: "https://apidev.tiehoitokunta.fi/v1",
//   production: "https://api.tiehoitokunta.fi/v1",
// };

// export const baseUrl =
//   process.env.REACT_APP_API_BASE_URL || BASES[ENV] || BASES.production;

const ENV = (
  process.env.REACT_APP_APP_ENV ||
  process.env.NODE_ENV ||
  "production"
).toLowerCase();

const BASES: Record<string, string> = {
  development: "http://localhost:3001/v1",
  stage: "https://apidev.tiehoitokunta.fi/v1",
  production: "https://api.tiehoitokunta.fi/v1",
};

export const baseUrl =
  process.env.REACT_APP_API_BASE_URL || BASES[ENV] || BASES.production;
